import React from 'react';
import Spinner from 'src/view/shared/Spinner';
import RecursoFormPage from '../form/RecursoFormPage';

function RecursoView(props) {
  const renderView = () => {
    const {record, drawer} = props;
    return <RecursoFormPage record={record} disabled={true} drawer={drawer} />;
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default RecursoView;
